// ADR-0158 — abrir en otra pestaña un archivo cuya URL firmada todavía no
// existe (vence a los 120 s: se pide en cada clic). La pestaña se abre
// DENTRO del clic —después del `await` el navegador ya perdió el gesto y
// la bloquea— y la URL se le asigna al llegar. Sin pestaña (bloqueada),
// navega la misma. Si pedir la URL falla, la pestaña vacía se cierra y el
// error sube al llamador. El mismo patrón que «Abrir» de un documento.
export async function abrirUrlFirmada(
  getUrl: () => Promise<string>,
  win: Pick<Window, "open" | "location"> = window
): Promise<void> {
  const tab = win.open("", "_blank");
  if (tab) tab.opener = null;
  try {
    const url = await getUrl();
    if (tab) tab.location.href = url;
    else win.location.assign(url);
  } catch (err) {
    tab?.close();
    throw err;
  }
}
